var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "div",
        {
          staticClass:
            "row align-items-center mt-5 mb-5 ml-1 justify-content-center"
        },
        [
          _c("div", { staticClass: "col-7" }, [
            _c("h5", { staticClass: "pb-3" }, [
              _vm._v("Auto Extending EWaybills")
            ]),
            _vm._v(" "),
            _c("form", [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "col-auto" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", [_vm._v("Auto Extend On")]),
                      _vm._v(" "),
                      _c("date-picker", {
                        attrs: { config: _vm.optionsDt },
                        model: {
                          value: _vm.date,
                          callback: function($$v) {
                            _vm.date = $$v
                          },
                          expression: "date"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-auto" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("div", {
                      staticStyle: { display: "block", height: "30px" }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: {
                          click: function($event) {
                            return _vm.updateExtended()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-check" }),
                        _vm._v(" Update\n                            ")
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("div", {
                        staticStyle: { display: "block", height: "30px" }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-btn",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true }
                            },
                            {
                              name: "b-modal",
                              rawName: "v-b-modal.newExtend",
                              modifiers: { newExtend: true }
                            }
                          ],
                          attrs: {
                            title: "Extend an EWaybill",
                            variant: "secondary"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-tools" }),
                          _vm._v(
                            "\n                                Extend an EWaybill\n                            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("table", { staticClass: "table table-striped table-sm" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.extensions, function(f) {
                return _c("tr", { key: f.ewbNo }, [
                  _c("td", [_vm._v(_vm._s(f.ewbNo))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm._f("date")(f.extendRequested)))]),
                  _vm._v(" "),
                  f.completed
                    ? _c("td", [
                        _c("span", [
                          f.extended
                            ? _c("span", { staticClass: "text-success" }, [
                                _c("i", { staticClass: "fa fa-check" })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !f.extended
                            ? _c("span", { staticClass: "text-danger" }, [
                                _c("i", { staticClass: "fa fa-times" })
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  f.completed
                    ? _c("td", [
                        f.extended
                          ? _c("span", { staticClass: "text-success" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm._f("date:'dd/MM/yyyy'")(f.newValidity)
                                  ) +
                                  "\n                    "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !f.extended
                          ? _c("span", { staticClass: "text-danger" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(f.errMsg) +
                                  "\n                    "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !f.completed
                    ? _c(
                        "td",
                        {
                          staticClass: "text-info",
                          attrs: { colspan: "2", "aria-colcount": "2" }
                        },
                        [
                          _vm._v(
                            "\n                       In Queue for Extension\n                    "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              }),
              0
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "newExtend",
          attrs: {
            id: "newExtend",
            title: "Extend E-Waybill",
            size: "lg",
            centered: "",
            lazy: "",
            "hide-footer": ""
          }
        },
        [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("State")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.credId,
                        expression: "credId"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.credId = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.creds, function(c) {
                    return _c(
                      "option",
                      { key: c.id, domProps: { value: c.id } },
                      [_vm._v(_vm._s(c.userName))]
                    )
                  }),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("EWB Number")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.ewb,
                      expression: "ewb"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    minlength: "12",
                    maxlength: "12",
                    pattern: "\\d{12}"
                  },
                  domProps: { value: _vm.ewb },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.ewb = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("div", {
                  staticStyle: { display: "block", height: "30px" }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info",
                    on: {
                      click: function($event) {
                        return _vm.checkValid()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-tools" }),
                    _vm._v(
                      "\n                        Add to Extend Queue\n                    "
                    )
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.checking
            ? _c(
                "div",
                { staticClass: "row justify-content-center text-center" },
                [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("h5", [_vm._v("Checking")]),
                      _vm._v(" "),
                      _c("loading")
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.error
            ? _c(
                "div",
                {
                  staticClass:
                    "row justify-content-center text-danger text-center"
                },
                [
                  _c("div", { staticClass: "col-3" }, [
                    _c("h5", [
                      _c("i", { staticClass: "fa fa-times" }),
                      _vm._v(" Cannot Add to Extend Queue")
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.error) +
                        "\n            "
                    )
                  ])
                ]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "thead-dark" }, [
      _c("tr", [
        _c("th", [_vm._v("EWB")]),
        _vm._v(" "),
        _c("th", [_vm._v("Old Validity")]),
        _vm._v(" "),
        _c("th", [_vm._v("Extended?")]),
        _vm._v(" "),
        _c("th", [_vm._v("New Validity")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19a1f30e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19a1f30e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExtendPage.vue
// module id = null
// module chunks = 